<mat-dialog-content>
    <title mat-dialog-title *ngIf="!this.veto.workspace">No Veto Found</title>
    <title mat-dialog-title *ngIf="this.veto.workspace">{{ teamOne.tricode }} vs {{ teamTwo.tricode }}</title>
    <table class="veto-info-table" *ngIf="this.veto.workspace">
        <tr>
            <th>Role</th>
            <th>Action</th>
            <th>Selection</th>
        </tr>
        <tr *ngFor="let action of veto.actions" 
            [ngClass]="{
            'ban-row': action.type == 'ban',
            'pick-row': action.type == 'pick',
            'side-row': action.type == 'side',
            'decider-row': action.type == 'decider'
            }">
            <td>{{ transformExecutorName(action.executor) }}</td>
            <td *ngIf="action.type != 'selectStartingTeam' && action.type != 'selectTeamAB'">{{ action.type }}</td>
            <td *ngIf="action.type == 'selectStartingTeam'">Opening Pick</td>
            <td *ngIf="action.type == 'selectTeamAB'">Team Choice</td>
            <td>{{ action.log }}</td>
        </tr>
    </table>
<mat-dialog-content>